import { NavLink } from 'react-router-dom';
import { cn, RoutePaths } from '@shared/utils';
import { Footer } from '@widgets/footer';
import logoImg from '@assets/images/logo.png';
import bgImg from '@assets/images/auth/bg-01.png';

export const MasterKeyPage = () => {
  return (
    <>
      <div className='absolute top-[10px] left-[67px] z-[16] h-[50px] w-[50px] max-md:top-0 max-md:left-0 max-md:z-[10] max-md:w-full max-md:bg-[#0f0f114d]'>
        <NavLink className='mx-auto flex h-[50px] w-[50px] items-center justify-center max-md:h-[44px]' to={RoutePaths.home.onNavigate()}>
          <img className='h-full w-full object-contain' src={logoImg} alt='logo' />
        </NavLink>
      </div>
      <div className='mx-auto flex h-[702px] max-w-[1440px] overflow-hidden max-md:relative max-md:z-[1] max-md:h-auto max-md:w-full max-md:flex-col-reverse'>
        <div className='relative z-[99] w-[140px] max-md:hidden' />
        <div
          className={cn(
            'relative z-99 h-[702px] w-full bg-right bg-no-repeat pl-37.5 text-left',
            'max-md:h-auto max-md:bg-size-[auto_70%] max-md:bg-position-[center_-85%] max-md:pt-[100%] max-md:pl-0',
          )}
          style={{ backgroundImage: `url(${bgImg})` }}
        >
          <div className='max-md:relative max-md:w-full max-md:px-4 max-md:pt-5 max-md:pb-12 max-md:after:absolute max-md:after:top-[-25px] max-md:after:left-[-50%] max-md:after:z-[-1] max-md:after:h-[200px] max-md:after:w-[200vw] max-md:after:rotate-[-7deg] max-md:after:bg-[#fff]'>
            <h2 className='mt-[103px] font-[Prata] text-[56px] text-[#272727] max-md:mt-0 max-md:text-center max-md:text-[28px]'>Master Key</h2>

            <div className='mt-4 flex items-center'>
              <span className='w-[55px] text-center font-[Prata] text-[40px] leading-relaxed text-[#272727]'>1.</span>
              <span className='ml-2 h-[47px] w-[369px] font-light text-[#000000]'>
                Search for Master Key EQ in the App Store for iOS devices or Google Play for Android devices.
              </span>
            </div>
            <div className='mt-4 flex items-center'>
              <span className='w-[55px] text-center font-[Prata] text-[40px] leading-relaxed text-[#272727]'>2.</span>
              <span className='ml-2 h-[47px] w-[369px] font-light text-[#000000]'>Open the Master Key application and allow notifications.</span>
            </div>
            <div className='mt-4 flex items-center'>
              <span className='w-[55px] text-center font-[Prata] text-[40px] leading-relaxed text-[#272727]'>3.</span>
              <span className='ml-2 h-[47px] w-[369px] font-light text-[#000000]'>
                In order to activate your Master Key app, please call: +44 203 530 5007
              </span>
            </div>
            <div className='mt-4 flex items-center'>
              <span className='w-[55px] text-center font-[Prata] text-[40px] leading-relaxed text-[#272727]'>4.</span>
              <span className='ml-2 h-[47px] w-[369px] font-light text-[#000000]'>
                During the call you will receive an activation SMS. Follow the link to activate.
              </span>
            </div>
            <div className='mt-4 flex items-center'>
              <span className='w-[55px] text-center font-[Prata] text-[40px] leading-relaxed text-[#272727]'>5.</span>
              <span className='ml-2 h-[47px] w-[369px] font-light text-[#000000]'>
                Trigger the activation by opening the page <br /> in your Master Key app.
              </span>
            </div>

            <div className='mt-5 flex items-center max-md:mt-8 max-md:w-full'>
              {/* <div className="mr-4 flex h-[40px] w-[138px] cursor-pointer items-center justify-center rounded-lg border border-[#000000] font-medium text-[#000000]" onClick={openRegister}>Registration</div> */}
              {/* <a className="auth-btn auth-b2" href='https://apps.apple.com/us/app/master-key/id1227460308' target='_blank' rel="noreferrer">Download New</a> */}
              <a href='https://apps.apple.com/us/app/master-key/id1227460308' target='_blank' rel='noreferrer'>
                <img src='../../assets/images/AppStoreLogo.png' alt='text' />
              </a>
              {/* <a href='https://play.google.com/store/apps/details?id=ltd.masterkey.app' target='_blank' rel='noreferrer' style={{ marginLeft: 10 }}>
                <img src='../../assets/images/googlePlayLogo.png' alt='text' />
              </a> */}
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
};
